export var AsyncBoundaryLoaderType;
(function (AsyncBoundaryLoaderType) {
    AsyncBoundaryLoaderType[AsyncBoundaryLoaderType["MastermindAsyncBoundaryLoader"] = 0] = "MastermindAsyncBoundaryLoader";
    AsyncBoundaryLoaderType[AsyncBoundaryLoaderType["TruncatedModelIteratingLoader"] = 1] = "TruncatedModelIteratingLoader";
    AsyncBoundaryLoaderType[AsyncBoundaryLoaderType["ExcelAsyncBoundaryLoader"] = 2] = "ExcelAsyncBoundaryLoader";
})(AsyncBoundaryLoaderType || (AsyncBoundaryLoaderType = {}));
export var AsyncBoundaryLoaderKind;
(function (AsyncBoundaryLoaderKind) {
    /**
     * Designed for the scenarios where we need flexible data pullings
     */
    AsyncBoundaryLoaderKind[AsyncBoundaryLoaderKind["Filtering"] = 0] = "Filtering";
    /**
     * Designed for generic workflows. To be used when we need to pull truncated subtrees of initial request.
     * Doesn't support filtering as we have the WF model schema and mastermind knows exactly what data should be returned.
     */
    AsyncBoundaryLoaderKind[AsyncBoundaryLoaderKind["ModelIterating"] = 1] = "ModelIterating";
})(AsyncBoundaryLoaderKind || (AsyncBoundaryLoaderKind = {}));
//# sourceMappingURL=iasync-boundary-loader.js.map